import { YCBConfigArray } from 'Config/types';

import { tinder } from './constants/domain';

export type ExperiencesConfig = {
  experience?:
    | {
        meta:
          | {
              titleKey: string;
              descriptionKey: string;
              imageUrl: string;
            }
          | undefined;
      }
    | undefined;
};

const experiencesConfig: YCBConfigArray<ExperiencesConfig> = [
  {
    settings: ['main'] as const,
    experience: undefined,
  },
  {
    settings: ['experience:select'],
    experience: {
      meta: {
        titleKey: 'TinderSelect.tinderSelect',
        descriptionKey: 'TinderSelect.openLandingPageHeader',
        imageUrl: `${tinder}/static/select.png`,
      },
    },
  },
  {
    settings: ['experience:matchmaker'],
    experience: {
      meta: {
        titleKey: 'MM.metaTitle',
        descriptionKey: 'Meta.description',
        imageUrl: `${tinder}/static/matchmaker.png`,
      },
    },
  },
  {
    settings: ['experience:gift'],
    experience: {
      meta: {
        titleKey: 'GiftCard.title',
        descriptionKey: 'GiftCard.title',
        imageUrl: `${tinder}/static/gift-card.png`,
      },
    },
  },
];

export default experiencesConfig;
